
export { CollectionName } from "/home/kachroov/trade-certification-main/packages/search-document-builders/src/registry/collection-registry.ts"
export { collectionAlias } from "./registry/schema-registry"